<router-outlet></router-outlet>
<app-secretaria-chat *ngIf="showHelp && (secretaria.isAberto$ | async)"></app-secretaria-chat>
<div class="loading-overlay" *ngIf="loading$ | async">
  <div class="spinner"></div>
</div>
